// utils/userApi.js
/**
 * Shared utility functions for user-related API calls
 */

/**
 * Search for users by name or email
 * @param {string} searchQuery - The search term (minimum 2 characters)
 * @returns {Promise<Array>} - Array of user objects
 */

import { axiosService } from 'shared/helpers/axios';

export const fetchUsers = async (searchQuery) => {
  if (!searchQuery || searchQuery.length < 2) {
    return [];
  }

  try {
    const response = await axiosService.get('/users/', {
      params: { search: searchQuery }
    });
    if (response.status === 200) {
      return response.data.results || response.data;
    }
    
    return [];
  } catch (err) {
    console.error('Error searching users:', err);
    return [];
  }
};

export const fetchUserById = async (userId) => {
  if (!userId) {
    return null;
  }

  try {
    const response = await axiosService.get(`/users/${userId}/`);
    if (response.status === 200) {
      return response.data;
    }
    
    return null;
  } catch (err) {
    console.error('Error fetching user by ID:', err);
    return null;
  }
};

